@if (user(); as user) {
  <div class="user-profile">
    <span class="user-profile__user-name">
      <ng-container *ngTemplateOutlet="username"></ng-container>
    </span>
    <button
      mat-icon-button
      #menuTrigger
      [matMenuTriggerFor]="menu"
      class="user-profile__menu-button"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu
      #menu="matMenu"
      class="user-profile__menu-panel"
      overlayPanelClass="user-profile__overlay-panel"
    >
      <div class="user-profile__menu" (click)="$event.stopPropagation()">
        <button class="user-profile__close-button" mat-icon-button (click)="closeMenu()">
          <mat-icon>close</mat-icon>
        </button>
        <div class="user-profile__avatar">
          @if (user.firstName || user.lastName) {
            {{ user.firstName?.substring(0, 1) }}{{ user.lastName?.substring(0, 1) }}
          } @else {
            <mat-icon>person</mat-icon>
          }
        </div>
        <span class="user-profile__header">
          <ng-container *ngTemplateOutlet="username"></ng-container>
        </span>
        @if (user.accountType !== "INDIVIDUAL" || accounts().length > 1) {
          <span class="user-profile__subheader">
            {{ activeAccount()?.name ?? user.accountName }}
          </span>
        }
        @if (user.firstName || user.lastName) {
          <span class="user-profile__subheader">
            {{ user.login }}
          </span>
        }
        <div class="user-profile__spacer"></div>
        @if (!isSsoOnly()) {
          <button
            (click)="changePassword()"
            mat-menu-item
            class="user-profile__menu-item"
            type="button"
          >
            {{ "USER_PROFILE.CHANGE_PASSWORD" | translate }}
          </button>
        }
        <button
          (click)="update2FA()"
          mat-menu-item
          class="user-profile__menu-item"
          type="button"
        >
          {{
            is2faEnabled()
              ? ("USER_PROFILE.DISABLE_2FA" | translate)
              : ("USER_PROFILE.ENABLE_2FA" | translate)
          }}
        </button>
        <button
          (click)="changeLanguage()"
          mat-menu-item
          class="user-profile__menu-item"
          type="button"
        >
          <ng-container> {{ "USER_PROFILE.LANGUAGE" | translate }}</ng-container>
          <mat-chip class="user-profile__menu-item__chip"
            >{{ language() | translateLanguage | translate }}
          </mat-chip>
        </button>
        <button
          mat-menu-item
          class="user-profile__menu-item"
          type="button"
          (click)="openAPIKeyDialog()"
        >
          {{ "USER_PROFILE.API_KEY_MANAGEMENT" | translate }}
        </button>
        <button
          (click)="openCustomSettingsDialog()"
          mat-menu-item
          class="user-profile__menu-item"
          type="button"
        >
          <mat-icon>settings</mat-icon>
          <ng-container> {{ "USER_PROFILE.SETTINGS" | translate }}</ng-container>
        </button>
        <button
          (click)="logout()"
          mat-menu-item
          class="user-profile__menu-item"
          type="button"
        >
          <mat-icon>logout</mat-icon>
          <ng-container> {{ "USER_PROFILE.LOG_OUT" | translate }}</ng-container>
        </button>
      </div>
    </mat-menu>
    <ng-template #username>
      @if (user.firstName || user.lastName) {
        {{ user.firstName }} {{ user.lastName }}
      } @else {
        {{ user.login }}
      }
    </ng-template>
  </div>
}
